import '@/lib/unpoly';
import { Application } from '@hotwired/stimulus';
import FundingMapController from '@/controllers/funding_map_controller';

const application = Application.start();
application.register('funding-map', FundingMapController);
